export default __webpack_public_path__ + "static/media/IMG_1514.16351de0.jpg";